import { createFileRoute } from '../utils/route-factory';

function About() {
  return <div className='p-2'>Hello from About!</div>;
}

export const Route = createFileRoute({
  path: '/about',
  component: About,
  type: 'public',
});
